export const API_CONFIG = {
  BASE_URL: import.meta.env.VITE_API_BASE_URL || '/api',
  TIMEOUT: 30000,
  ENDPOINTS: {
    AUTH: {
      LOGIN: '/ums/auth/login',
      REGISTER: '/ums/auth/register',
      ACCEPT_INVITE: '/ums/auth/accept-invite',
      INVITE_STATUS: '/ums/auth/invite-status',
      LOGOUT: '/ums/auth/logout',
      REFRESH: '/ums/auth/refresh',
      ME: '/ums/auth/me',
      FORGOT_PASSWORD: '/ums/auth/forgot-password',
      RESET_PASSWORD: '/ums/auth/reset-password',
    },
    ORGANIZATIONS: {
      REQUEST: '/ums/auth/request-access',
      LIST: '/ums/orgs',
      APPROVE: (id: string) => `/ums/auth/registration-requests/${id}/approve`,
      REJECT: (id: string) => `/ums/auth/registration-requests/${id}/reject`,
      SUSPEND: (id: string) => `/ums/orgs/${id}/suspend`,
      ROTATE_SECRET: (id: string) =>
        `/ums/orgs/${id}/enroll-secret/rotate`,
      MY_ENROLL_SECRET: '/asset/assets/enroll-secret',
    },
    USERS: {
      LIST: '/ums/users',
      GET: (id: number) => `/ums/users/${id}`,
      CREATE: '/ums/users',
      UPDATE: (id: number) => `/ums/users/${id}`,
      DELETE: (id: number) => `/ums/users/${id}`,
      INVITE: '/ums/users/org-members/invite',
    },
    ASSETS: {
      LIST: '/asset/assets',
      GET: (id: string) => `/asset/assets/${id}`,
      CREATE: '/asset/assets',
      UPDATE: (id: string) => `/asset/assets/${id}`,
      DELETE: (id: string) => `/asset/assets/${id}`,
    },
    OSQUERY: {
      ENROLL: '/asset/osquery/enroll',
      CONFIG: '/asset/osquery/config',
      LOG: '/asset/osquery/log',
      DISTRIBUTED_READ: '/asset/osquery/distributed/read',
      DISTRIBUTED_WRITE: '/asset/osquery/distributed/write',
      LIST_AGENTS: '/asset/osquery/agents',
      LIST_LOGS: '/asset/osquery/logs',
    },
    NIRP: {
      // Incidents
      INCIDENTS: '/incidents/incidents/',
      INCIDENT_DETAIL: (id: string) => `/incidents/incidents/${id}/`,
      INCIDENT_STATUS: (id: string) => `/incidents/incidents/${id}/update_status/`,
      INCIDENT_ATTACHMENT: (id: string) => `/incidents/incidents/${id}/upload_attachment/`,
      INCIDENT_DASHBOARD: '/incidents/incidents/dashboard_summary/',
      INCIDENT_STATS: '/incidents/incidents/statistics/',
      INCIDENT_OVERVIEW: '/incidents/incidents/security_overview/',
      INCIDENT_BULK_IMPORT: '/incidents/incidents/bulk_import/',
      INCIDENT_FORM_CHOICES: '/incidents/incidents/form_choices/',
      INCIDENT_EXPORT_CSV: '/incidents/incidents/export_csv/',
      // IOCs
      IOCS: '/incidents/iocs/',
      // Threat Intel
      INTEL: '/incidents/intel/',
      INTEL_INDICATORS: '/incidents/intel/indicators/',
      INTEL_INCIDENT_IOCS: '/incidents/intel/incident_iocs/',
      INTEL_PROMOTE: '/incidents/intel/promote/',
      INTEL_DISTRIBUTE: (id: string) => `/incidents/intel/${id}/distribute/`,
      INTEL_ACKNOWLEDGE: (id: string) => `/incidents/intel/${id}/acknowledge/`,
      // Compliance
      FRAMEWORKS: '/incidents/compliance/frameworks/',
      SCORES: '/incidents/compliance/scores/',
      SCORES_SUMMARY: '/incidents/compliance/scores/summary/',
      FINDINGS: '/incidents/compliance/findings/',
    },
    SUPPORT: {
      TICKETS: '/api/support/tickets',
      TICKET_DETAIL: (id: string) => `/api/support/tickets/${id}`,
      TICKET_STATUS: (id: string) => `/api/support/tickets/${id}/status`,
      TICKET_RESPONSES: (id: string) => `/api/support/tickets/${id}/responses`,
      RESOURCES: '/api/support/knowledge-base/resources',
      RESOURCE_DETAIL: (id: string) => `/api/support/knowledge-base/resources/${id}`,
      FAQS: '/api/support/knowledge-base/faqs',
      FAQ_DETAIL: (id: string) => `/api/support/knowledge-base/faqs/${id}`,
      HEALTH_STATUS: '/api/support/health-status/components',
    },
  },
} as const;
